import {
  faComment,
  faCommentLines,
  faList,
} from '@fortawesome/pro-light-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { FavoritesType } from '../../pages/Favorites';
import SidebarItemsContainer from '../sidebar/SidebarItemsContainer';
import SidebarItem from '../sidebar/SidebarItem';

const FavoritesSidebar = () => {
  const navigate = useNavigate();
  const { type } = useParams();

  return (
    <SidebarItemsContainer>
      {[
        {
          id: undefined,
          title: 'Alle',
          icon: faList,
        },
        {
          id: FavoritesType.Task,
          title: 'Aktivitäten',
          icon: faComment,
        },
        {
          id: FavoritesType.TaskDefinition,
          title: 'Vorlagen',
          icon: faCommentLines,
        },
      ].map(({ id, title, icon }) => (
        <SidebarItem
          key={id ?? 'all'}
          onClick={() => navigate(`/favorites${id ? `/${id}` : ''}`)}
          isActive={type === id}
          label={title}
          icon={icon}
        />
      ))}
    </SidebarItemsContainer>
  );
};

export default FavoritesSidebar;
